<template>
    <v-expand-transition>
        <v-card v-show="showSearch" class="elevation-1 mx-auto">
            <v-card-title class="subtitle-2 font-weight-bold">검색필터</v-card-title>
            <v-card-text class="py-0">
                <v-row>
                    <v-col cols="3" md="3" class="py-0">
                        <v-select v-model="query['_category']" :items="categories" label="카테고리" placeholder=" " clearable outlined dense hide-details @input="setQuery"></v-select>
                    </v-col>
                    <v-col cols="3" sm="3" class="py-0">
                        <v-select v-model="query[`searchKey`]" :items="searchKeys" item-text="text" item-value="value" label="검색조건" placeholder=" " clearable outlined dense hide-details></v-select>
                    </v-col>
                    <v-col cols="3" sm="3" class="py-0">
                        <v-text-field
                        v-model="query[`searchValue`]"
                        label="검색어"
                        placeholder=" "
                        outlined
                        dense
                        hide-details
                        @keydown.enter="setQuery"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="1.5" class="py-0">
                        <v-select v-model="query[`onSale`]" :items="[{ text: '판매', value: 'true' }, { text: '품절', value: 'false' }]" label="판매상태" placeholder=" " clearable outlined dense hide-details @input="setQuery"></v-select>
                    </v-col>
                    <v-col cols="1.5" class="py-0">
                        <v-select v-model="query[`onDisplay`]" :items="[{ text: '전시', value: 'true' }, { text: '숨김', value: 'false' }]" label="전시상태" placeholder=" " clearable outlined dense hide-details @input="setQuery"></v-select>
                    </v-col>
                </v-row>
                <v-row class="mt-6" align="center">
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    rounded
                    text
                    @click="setQuery"
                    ><v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-expand-transition>
</template>

<script>
import api from "@/api";
let initQuery = (query = {}) => ({
    ...query,

    _category: query?._category || null,
    searchKey: query?.searchKey || null,
    searchValue: query?.searchValue || null,
    onSale: query?.onSale || null,
    onDisplay: query?.onDisplay || null
});
export default {
    props: {
        showSearch: { type: Boolean, default: true },
    },
    data: () => ({
        query: initQuery(),
        searchKeys: [
            { text: "상품명", value: "name" },
            { text: "상품코드", value: "code" },
        ],
        categories: [],
    }),
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            let { categories } = await api.console.shop.delivery.categories.gets({ params: { depth: 1 } });
            this.categories = categories.map(({ name, _id }) => ({ text: name, value: _id }));

            this.sync();
        },
        sync() {
            this.query = initQuery(this.$route.query);
        },
        setQuery() {
            let { ...query } = this.query;

            delete query.page;

            if (!query["searchKey"]) delete query["searchKey"];
            if (!query["searchValue"]) delete query["searchValue"];
            if (!query["_category"]) delete query["_category"];
            if (query["onSale"] == null) delete query["onSale"];
            if (query["onDisplay"] == null) delete query["onDisplay"];

            this.$router.push({ query });
        },
    },
    watch: {
        "$route.query"() {
            this.sync();
        },
    },
};
</script>

<style>
</style>